import React from 'react';
import PropTypes from 'prop-types';
// common components
import FormField from './../../../common/Forms/FormField/FormField';

const ManageUser = ({ onDelete, userDetails, onChange, isEdit }) => {
	if (onDelete) {
		return (
			<div className='ManageUser'>
				<div>Are you sure, you want to delete?</div>
			</div>
		);
	};

	return (
		<div className='ManageUser'>
			<div className="half">
				<div>
					<FormField
						label="first name"
						name="firstname"
						type="text"
						placeholder="enter firstname"
						value={userDetails.firstname}
						onChange={onChange}
						validate={['required']}
						autoFocus
                        maxLength={50}
					/>
				</div>
				<div>
					<FormField
						label="last name"
						name="lastname"
						type="text"
						placeholder="enter lastname"
						value={userDetails.lastname}
						onChange={onChange}
						validate={['required']}
                        maxLength={50}
					/>
				</div>
			</div>
			<div className="half">
				<div>
					<FormField
						label="e-mail"
						name="email"
						type="email"
						placeholder="enter email"
						value={userDetails.email}
						onChange={onChange}
						validate={['required', 'email']}
                        maxLength={50}
                        disabled={isEdit}
					/>
				</div>
				<div>
					<FormField
						label="phone"
						name="phone"
						type="number"
						placeholder="enter phone number"
						value={userDetails.phone}
						onChange={onChange}
						maxLength={10}
						validate={['rangeLength10']}
					/>
				</div>
			</div>
			<div className="half">
				<div>
					<FormField
						label="country"
						name="country"
						type="text"
						placeholder="enter country name"
						value={userDetails.country}
						onChange={onChange}
                        maxLength={50}
					/>
				</div>
				<div>
					<FormField
						label="city"
						name="city"
						type="text"
						placeholder="enter city name"
						value={userDetails.city}
						onChange={onChange}
                        maxLength={50}
					/>
				</div>
			</div>
		</div>
	);
}

ManageUser.propTypes = {
	// onDelete: PropTypes.bool,
	// onChange: PropTypes.func,
	// question: PropTypes.string,
	// options: PropTypes.instanceOf(Array),
	// onChangeOption: PropTypes.func,
	// onCreateOption: PropTypes.func,
	// onDestroyOption: PropTypes.func,
	// onToggleCorrectOption: PropTypes.func
};

ManageUser.defaultProps = {
	// onDelete: false,
	// onChange: () => {},
	// question: 'PropTypes.string',
	// options: [],
	// onChangeOption: () => {},
	// onCreateOption: () => {},
	// onDestroyOption: () => {},
	// onToggleCorrectOption: () => {}
};

export default ManageUser;



// WEBPACK FOOTER //
// ./components/User/ManageUser/ManageUser.js